export function extractRpcErrorMessage(err: unknown): string | null {
  if (err && typeof err === 'object' && 'message' in err) {
    const message = (err as { message: unknown }).message;
    return typeof message === 'string' ? message : null;
  }
  return null;
}

export type AppointmentRescheduleErrorKind =
  | 'conflict'
  | 'resource_selected'
  | 'resource_required'
  | 'permission'
  | 'invalid_time'
  | 'not_allowed'
  | 'unknown';

export function classifyAppointmentRescheduleError(err: unknown): AppointmentRescheduleErrorKind {
  const msg = (extractRpcErrorMessage(err) ?? '').toLowerCase();
  if (msg.includes('conflict: selected resource is not available')) return 'resource_selected';
  if (msg.includes('conflict: required resource is not available')) return 'resource_required';
  if (msg.includes('conflict')) return 'conflict';
  if (msg.includes('forbidden') || msg.includes('unauthorized') || msg.includes('not a member')) {
    return 'permission';
  }
  if (
    msg.includes('cancelled') ||
    msg.includes('no_show') ||
    msg.includes('cannot be rescheduled') ||
    msg.includes('only upcoming')
  ) {
    return 'not_allowed';
  }
  if (
    msg.includes('ends_at') ||
    msg.includes('starts_at') ||
    msg.includes('invalid:') ||
    msg.includes('invalid-input')
  ) {
    return 'invalid_time';
  }
  return 'unknown';
}

export function appointmentRescheduleErrorI18nKey(kind: AppointmentRescheduleErrorKind): string {
  switch (kind) {
    case 'conflict':
      return 'appointments.errors.reschedule_unavailable';
    case 'resource_selected':
      return 'appointments.errors.resource_selected_unavailable';
    case 'resource_required':
      return 'appointments.errors.resource_required_unavailable';
    case 'permission':
      return 'appointments.errors.reschedule_permission';
    case 'invalid_time':
      return 'appointments.errors.reschedule_invalid_time';
    case 'not_allowed':
      return 'appointments.errors.reschedule_not_allowed';
    case 'unknown':
      return 'appointments.errors.reschedule_failed';
    default: {
      const _exhaustive: never = kind;
      return _exhaustive;
    }
  }
}
